<template>
    <div>
        <div
                v-if="viewStates.show_preloader_spinner"
                class="loader_spinner d-flex justify-content-center bg-white align-items-center position-absolute w-100 h-100"
        >
            <div class="spinner-border"></div>
        </div>
        <div class="main-wrap">
            <router-view
                :style="{
                             'display': '-webkit-flex',
                             'display': 'flex',
                             'flex-direction': 'column',
                             'min-height': '100vh'
                         }"
            ></router-view>
        </div>
    </div>
</template>

<script>

import {useStatesStorage} from "./stores/store";
import {storeToRefs} from "pinia";

export default {
setup() {
    //console.log('app');

    const statesStorage = useStatesStorage();
    const { viewStates } = storeToRefs(statesStorage);
    //console.log('viewStates', JSON.stringify(viewStates.value));
    return {
        viewStates

    }
},
components: {}
}
</script>

<style scoped>
    .loader_spinner{
        z-index: 1;
    }
</style>